<template>
  <YunoAPM :data="[$route.params.paymentMethodType, $route.params.idSessionHash]"></YunoAPM>
</template>

<script>
import YunoAPM from '@/components/PaymentMethods/YunoAPM'

export default {
  name: 'YunoAPMRedirect',
  components: {
    YunoAPM
  }
}
</script>